"use strict";

angular.module('app.userlogin').service('betaModalService', ['$modal',
    function ($modal) {

        var modalDefaults = {
			backdrop: true,
			keyboard: false,
            modalFade: false,
            windowClass: 'asa-msg-modal-full',
            templateUrl: '/app/login/beta/betaModal.html'
        };

        var modalOptions = {};

        this.showModal = function (customModalDefaults, customModalOptions) {
            if (!customModalDefaults) customModalDefaults = {};
            customModalDefaults.backdrop = 'static';
            return this.show(customModalDefaults, customModalOptions);

        };

        this.show = function (customModalDefaults, customModalOptions) {
            var tempModalDefaults = {};
            var tempModalOptions = {};

            //Map angular-ui modal custom defaults to modal defaults defined in service
            angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

            //Map modal.html $scope custom properties to defaults defined in service
            angular.extend(tempModalOptions, modalOptions, customModalOptions);

            tempModalDefaults.controller = ['$scope', '$modalInstance',
                function ($scope, $modalInstance) {

                    $scope.modalOptions = tempModalOptions;

                    $scope.ok = function () {                                        
                        $modalInstance.close(true);                 
                    };

                    $scope.cancel = function () {
                        $modalInstance.close(false);
                    };                   

                }];

            return $modal.open(tempModalDefaults).result;
        };

    }]);